import * as moment from 'moment';
import { DateRange } from '../models/date-range';
import { TIMEZONE } from '../services/language.service';

/**
 * Return if endDate is in the same Month as startEnd.
 *
 * @param startDate a date to compare.
 * @param endDate a date to compare.
 */
export function nextMonth(startDate: string, endDate: string): boolean {
  const start = moment(startDate, 'YYYY-MM');
  const end = moment(endDate, 'YYYY-MM');
  return start.isSame(end, 'months');
}

export function sortByDateDesc(a: Date, b: Date) {
  if (a < b) {
    return 1;
  } else if (a > b) {
    return -1;
  }
  // a must be equal to b
  return 0;
}

export function createDateRange(
  date: string,
  startTime: string = '00:00:00',
  endTime: string = '23:59:59'
): DateRange {
  const firstDay = new Date(date);
  const lastDay = new Date(date);

  const startMoment = moment.tz(firstDay, TIMEZONE);
  startMoment.set({
    // Set the time for the start
    hour: parseInt(startTime.split(':')[0], 10),
    minute: parseInt(startTime.split(':')[1], 10),
    second: parseInt(startTime.split(':')[2], 10),
    millisecond: 0, // Important: Reset milliseconds to avoid unexpected behavior
  });

  const endMoment = moment.tz(lastDay, TIMEZONE);
  endMoment.set({
    // Set the time for the end
    hour: parseInt(endTime.split(':')[0], 10),
    minute: parseInt(endTime.split(':')[1], 10),
    second: parseInt(endTime.split(':')[2], 10),
    millisecond: 999, // Important: Set milliseconds to 999 for end of day
  });

  return {
    start: startMoment.format(),
    end: endMoment.format(),
  } as DateRange;
}
